import { donationsHandlers } from './donations'

export const organisationsHandlers = [...donationsHandlers]
